// extracted by mini-css-extract-plugin
export default {"container":"vubPoD2q0v7ZmSz2rALN"};